import React from "react";

const Entry = ({ serviceno, time, load, type }) => {
  const seats = {
    SEA: "Seats Available",
    SDA: "Standing Available",
    LSD: "Limited Standing",
  };

  const seatsIcon = {
    SEA: ["fa-user-o", "fa-user-o", "fa-user"],
    SDA: ["fa-user-o", "fa-user", "fa-user"],
    LSD: ["fa-user", "fa-user", "fa-user"],
  };

  const vehicle = {
    SD: "Single",
    DD: "Double",
    BD: "Bendy",
  };

  return (
    <div className="w-full max-w-screen-sm px-4 py-2 rounded bg-white m-2 flex">
      <div className="w-1/4 items-center justify-center flex text-xl font-mono">
        <h1>{serviceno}</h1>
      </div>

      <div className="flex flex-col">
        <p className="font-semibold">{time}</p>

        <div className="flex items-center">
          <p>Fill | </p>
          {seatsIcon[load].map((icon) => (
            <i className={"fa fa-fw " + icon} aria-hidden="true"></i>
          ))}
          <div className="px-2">
            <i className="fa fa-fw fa-bus  inline-block" aria-hidden="true"></i>
            <p className="inline-block"> | {vehicle[type]}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Entry;
